<template>
    <section>
        <main class="main animated fadeIn faster" :class="{ 'expand-main': isMenuCollapse }">
            <div class="container-fluid w-100 mb-3 p-3   bg-white rounded">
                <LoadingSpinner v-if="loading" />

                <div class="row" v-if="!loading">
                    <h2>Microsoft Licences</h2>
                    <div class="col-12">
                        <Table :cols="cols" :headers="headers" :data="licences" :loading="loading" />

                    </div>
                </div>
            </div>
        </main>
    </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { adminService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";
import { statusBadgeMixin, linksMixin } from "@/_mixins/";



export default {
    name: "microsft_licences",
    computed: {
        ...mapState({
            loading: (state) => state.emails.loading,
            selected: (state) => state.emails.selected.data,
            currentUser: (state) => state.authentication.user,
            isMenuCollapse: (state) => state.sidebar.isNavOpen,
            filtersSystem: (state) => state.campaigns.filtersSystem,
        }),
        flag() {
            const flag = this.flags.find((el) => el.id === this.language_id).text;
            return require("@/assets/images/flags/" + flag);
        },
        flag2() {
            return (countryId) => {
                const flag = this.countries.find((el) => el.id === countryId).iso;
                return require("@/assets/images/flags/" + flag + ".svg");
            };
        },
        clientPhoneQty() {
            return this.clients.length;
        },
    },
    mixins: [statusBadgeMixin, linksMixin],
    data() {
        return {
            licences: [],
            loading: true,
            cols: [
                [
                    {
                        value: "email_workspace",
                    },
                ],
                [
                    {
                        value: "total_licences",
                    },
                ],
                [   
                    {
                        value: "available_licences",
                    },
                   
                ],
                  [   
                    {
                        value: "accounts",
                        type: "html" 
                    },
                   
                ],
            ],
            headers: [
                {
                    label: "Workspace",
                    percentage: "12.5%",
                    class: "overflowhide",
                    permission: "adminClients",
                    id: 1,
                },
                {
                    label: "Total Licences",
                    percentage: "10.5%",
                    class: "overflowhide",
                    permission: "adminClients",
                    id: 2,
                },
                {
                    label: "Available Licences",
                    percentage: "12.5%",
                    class: "overflowhide",
                    permission: "adminClients",
                    id: 1,
                },
                  {
                    label: "Account without licences",
                    percentage: "5.5%",
                    class: "overflowhide",
                    permission: "adminClients",
                    id: 1,
                },
            ],
            getOrderNumber: 0,
            responseOrderNumber: 0,
        };
    },
    components: {
        Table,
        LoadingSpinner,
        Pagination,
    },

    created() {
        this.getMicrosoftLicences()
    },


    methods: {
        ...mapActions("headertopbar", {
            setCurrentRoute: "setRoute",
            setCurrentRouteChild: "setRouteChild",
        }),
        ...mapActions("emails", {
            getByIdAllSource: "getByIdAllSource",
            startLoading: "startLoading",
        }),
        udpdateHeader(route) {
            this.setCurrentRoute({ page: route });
        },
        hasPermissions(perm) {
            return this.$store.getters["authentication/hasPermissions"](perm);
        },

        getMicrosoftLicences() {
            this.loading = true;
            adminService
                .getMicrosoftLicences()
                .then((response) => {
                    this.licences = response.result;
                   this.licences = response.result.map((item) => {
  item.accounts = item.accounts
    ? item.accounts
        .split(',')
        .map((acc) => acc.trim())
        .join('<br>') // Esto mete los saltos de línea en HTML
    : '';
  return item;
});
                    this.loading = false;
                })
                .catch((error) => {
                    console.error("Error fetching Microsoft Licences:", error);
                    this.loading = false;
                });
        },



    },
};
</script>

<style scoped></style>
